import { cn } from '@neo/lib/utils'
import { Skeleton } from '@neo/primitives/skeleton'
import DOMPurify from 'dompurify'
import { lazy, Suspense } from 'react'

const Markdown = lazy(() => import('react-markdown'))

interface DocumentContentProps {
  content: string
  isHtml?: boolean
}

const contentClassName = cn(
  'prose prose-sm max-w-none text-s-400 text-foreground dark:prose-invert',
  'prose-headings:font-inter prose-headings:text-foreground',
  'prose-h1:text-h2-500 prose-h2:text-h3-500 prose-h3:text-h4-500 prose-h4:text-p-500',
  'prose-a:text-brand-text prose-strong:text-foreground prose-code:text-foreground',
  'prose-pre:bg-bg2 prose-pre:text-foreground prose-blockquote:border-st2',
  'prose-blockquote:text-secondary prose-hr:border-st2 prose-th:text-secondary',
  'prose-td:border-st2',
)

export const DocumentContent = ({ content, isHtml = false }: DocumentContentProps) =>
  isHtml ? (
    <div
      className={contentClassName}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
    />
  ) : (
    <Suspense fallback={<Skeleton className="h-4 w-full" />}>
      <Markdown className={contentClassName} skipHtml disallowedElements={['img', 'a']}>
        {content}
      </Markdown>
    </Suspense>
  )
